import { stringValidator } from '#validation/common/validators';
import { REGION_NAME_CONTENT_REGEX, REGION_NAME_ENDS_WITH_REGEX, REGION_NAME_MIN_LENGTH, REGION_NAME_START_WITH_REGEX, } from '../constants';
export const storageRegionNameValidator = stringValidator({
    minLength: {
        min: REGION_NAME_MIN_LENGTH,
        error: 'filespace.storageRegionName.minLength',
    },
    formats: [
        {
            regex: REGION_NAME_START_WITH_REGEX,
            error: 'filespace.storageRegionName.startsWith',
        },
        {
            regex: REGION_NAME_ENDS_WITH_REGEX,
            error: 'filespace.storageRegionName.endsWith',
        },
        {
            regex: REGION_NAME_CONTENT_REGEX,
            error: 'filespace.storageRegionName.invalidChar',
        },
    ],
});
